/* eslint-disable */
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { SelectionList } from "../selection-list";
import { FieldPreviewComponent } from "../../field-preview.component";

@Component({
    selector: "single-selection-dropdown",
    templateUrl: "./single-selection-dropdown.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectionDropdownComponent extends FieldPreviewComponent implements OnInit, OnDestroy {
    constructor(private _changeDetector: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.field.onChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((changed) => {
            this._changeDetector.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get selectionList() {
        return this.field as SelectionList;
    }
}
